import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { Toaster } from 'react-hot-toast';

const App = () => (
  <ThemeCustomization>
    <ScrollTop>
      <Routes />
      <Toaster position="top-center" reverseOrder={false} />
    </ScrollTop>
  </ThemeCustomization>
);

export default App;
